export const hasNonNumericPlaceholder = (input: string): boolean => {
  const regex = /\{([^\d{}]+)\}/
  return regex.test(input)
}

export const extractNonNumericPlaceholders = (input: string): string[] => {
  const matches = input.match(/\{([^}]+)\}/g)
  if (!matches) return []

  return matches
    .map((match) => match.replace(/[{}]/g, ''))
    .filter((placeholder) => isNaN(Number(placeholder)))
}

export const replacePlaceholdersWithValue = (endPoint: string, value: string): string => {
  return endPoint.replace(/\{(.+?)\}/g, value)
}

export const replacePlaceholdersWithData = (endPoint: string, data: any): string => {
  const placeholders = extractNonNumericPlaceholders(endPoint)
  let replacedEndpoint = endPoint

  placeholders.forEach((placeholder) => {
    const value = (data as any)[placeholder]
    if (value !== undefined) {
      replacedEndpoint = replacedEndpoint.replace(
        new RegExp(`\\{${placeholder}\\}`, 'g'),
        value
      )
    }
  })

  return replacedEndpoint
}
